import { CustomImageField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  change,
  Field,
  FieldArray,
  formValueSelector,
  getFormSyncErrors,
  isDirty,
  reset,
} from "redux-form"
import { renderFormFields } from "./utils"

const FormTab = ({
  vendorId,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
  formSyncErrors,
  change,
  selectedProductCategory,
  additionalImage,
  bannerImage,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (
      !tabIsActive &&
      isDirty &&
      (!formSyncErrors || Object?.keys(formSyncErrors)?.length === 0)
    ) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>SET UP FORM IMAGES</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2" style={{ minWidth: "140px" }}>
              <label>Banner image: </label>
            </Col>
            <Col xs="auto">
              <Field
                name="bannerImage"
                component={CustomImageField}
                onDelete={() => {
                  if (selectedProductCategory?.banner_url) {
                    change("form.delete_banner", 1)
                  }
                }}
                onChange={() => {
                  if (selectedProductCategory?.banner_url) {
                    change("form.delete_banner", 1)
                  }
                }}
              />
            </Col>
            <Col className="d-flex flex-row justify-content-end">
              {bannerImage && bannerImage?.editedImage && (
                <img
                  src={bannerImage?.editedImage ? bannerImage?.editedImage : ""}
                  alt="bannerImage"
                  className="rounded avatar-xl"
                  style={{ blockSize: "auto" }}
                />
              )}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs="auto" className="mt-2">
              <label>Additional image: </label>
            </Col>
            <Col xs="auto">
              <Field
                name="additionalImage"
                component={CustomImageField}
                onDelete={() => {
                  if (selectedProductCategory?.file_url) {
                    change("form.delete_additionalImage", 1)
                  }
                }}
                onChange={() => {
                  if (selectedProductCategory?.file_url) {
                    change("form.delete_additionalImage", 1)
                  }
                }}
              />
            </Col>
            <Col className="d-flex flex-row justify-content-end">
              {additionalImage && additionalImage?.editedImage && (
                <img
                  src={
                    additionalImage?.editedImage
                      ? additionalImage?.editedImage
                      : ""
                  }
                  alt="additionalImage"
                  className="rounded avatar-xl"
                  style={{ blockSize: "auto" }}
                />
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>
          <h4>SET UP FORM FIELDS</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <label>Select form fields displayed in the order form</label>
            </Col>
          </Row>
          <Row>
            <Col xs="auto">
              <FieldArray
                name="formFields"
                component={renderFormFields}
                rerenderOnEveryChange={true}
                change={change}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PRODUCT_CATEGORIES)

const mapStateToProps = state => ({
  additionalImage: selector(state, "form.additionalImage"),
  bannerImage: selector(state, "form.bannerImage"),
  vendorId: state.Login.vendorId,
  isDirty: isDirty(FORM_NAMES.PRODUCT_CATEGORIES)(state, ...["form"]),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT_CATEGORIES)(state),
  selectedProductCategory:
    state.ProductsAndSubscriptions.selectedProductCategory,
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.PRODUCT_CATEGORIES)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PRODUCT_CATEGORIES, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormTab)
